var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"reduce":(user_options) => user_options.code,"options":_vm.user_options,"multiple":true,"label":'name'},on:{"search":_vm.fetchOptions,"input":_vm.selectedOption},model:{value:(_vm.newselectedValueOption),callback:function ($$v) {_vm.newselectedValueOption=$$v},expression:"newselectedValueOption"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }